import EmptyRouterView from '@/components/common/EmptyRouterView'

// Nadawanie
import ShipmentsSendings from '@/views/Shipments/Sendings/Index'

// Tracking
import ShipmentsTracking from '@/views/Shipments/Tracking/ManageTracking/Index'

// Zawieszki v2
import ShippingPackageLabelsLabelsV2 from '@/views/Shipments/PackageLabels-v2/Index'
import ShippingPackageLabelsLabelsLabelV2 from '@/views/Shipments/PackageLabels-v2/ShippingLabel'
import ShippingPackageLabelsCampaignLabel from '@/views/Shipments/PackageLabels-v2/ShippingLabelCampaign'

//GeneratorEtykiet
import LabelsGenerator from '@/views/Shipments/LabelsGenerator/Index'
import LabelsGeneratorAll from '@/views/Shipments/LabelsGenerator/LabelsGeneratorAll'
import StandardLabels from '@/views/Shipments/LabelsGenerator/StandardLabels'
import BillboardLabels from '@/views/Shipments/LabelsGenerator/BillboardLabels'
import LabelsPrintHistory from '@/views/Shipments/LabelsGenerator/LabelsPrintHistory'
import RevisoryLabels from '@/views/Shipments/LabelsGenerator/RevisoryLabels'

// Zlecenia spedycyjne
import ShipmentsShipmentsOrders from '@/views/Shipments/ShipmentsOrders/Index'
import ShipmentsShipmentsOrdersShipmentsOrder from '@/views/Shipments/ShipmentsOrders/ShipmentsOrder/Index'

// Odbiory osobiste
import ShipmentsPersonalPickups from '@/views/Shipments/PersonalPickups/Index'
import ShipmentsPersonalPickupsPersonalPickup from '@/views/Shipments/PersonalPickups/PersonalPickup'
import ShipmentsPersonalPickupsPersonalPackagesPickup from '@/views/Shipments/PersonalPickups/PersonalPackagesPickup'

// Pojedynczy raport szczegółowy nadawania
import ReportsCommonShipmentReport from '@/views/Reports/Common/ShipmentReport'

export default [
    {
        path: '',
        component: EmptyRouterView,
        meta: {
            title: 'Wysyłki',
            menuRendered: true,
            menuTitle: 'Wysyłki',
            icon: 'mdi-package-variant-closed'
        },
        children: [
            {
                path: '/shipments/sendings',
                name: 'shipmentsSendings',
                component: ShipmentsSendings,
                meta: {
                    title: 'Wysyłki / Nadawanie',
                    menuRendered: true,
                    menuTitle: 'Nadawanie',
                    requiresAuth: true,
                    permission: 'sendings',
                },
            },
            {
                path: '/shipments/sendings/reporting/:id',
                name: 'shipmentsSendingsReport',
                component: ReportsCommonShipmentReport,
                meta: {
                    title: 'Wysyłki / Nadawanie / Szczegóły raportu',
                    requiresAuth: true,
                    permission: 'shipments_read',
                }
            },
            // {
            //     path: '/shipments/package-labels',
            //     name: 'shipmentsPackageLabels',
            //     component: EmptyRouterView,
            //     meta: {
            //         title: 'Wysyłki / Zawieszki',
            //         menuRendered: true,
            //         menuTitle: 'Zawieszki',
            //         requiresAuth: true,
            //         permission: 'labels',
            //     },
            //     redirect: { name: 'shipmentsPackageLabelsLabels' },
            //     children: [
            //         {
            //             path: '/shipments/package-labels/labels',
            //             name: 'shipmentsPackageLabelsLabels',
            //             component: ShippingPackageLabelsLabels,
            //             meta: {
            //                 title: ' Wysyłki / Zawieszki / Etykiety',
            //                 requiresAuth: true,
            //                 permission: 'labels_read',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/labels/create',
            //             name: 'shipmentsPackageLabelsLabelsCreate',
            //             component: ShippingPackageLabelsLabelsLabel,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Nowa etykieta',
            //                 requiresAuth: true,
            //                 permission: 'labels_create',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/labels/edit/:id',
            //             name: 'shipmentsPackageLabelsLabelsEdit',
            //             component: ShippingPackageLabelsLabelsLabel,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Edycja etykiety',
            //                 requiresAuth: true,
            //                 permission: 'labels_update',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/labels/renew/:id',
            //             name: 'shipmentsPackageLabelsLabelsRenew',
            //             component: ShippingPackageLabelsLabelsLabel,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Wznowienie etykiety',
            //                 requiresAuth: true,
            //                 permission: 'labels_update',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/addresses',
            //             name: 'shipmentsPackageLabelsAddresses',
            //             component: ShippingPackageLabelsAddresses,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Adresy',
            //                 requiresAuth: true,
            //                 permission: 'labels_read',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/addresses/create',
            //             name: 'shipmentsPackageLabelsAddressesCreate',
            //             component: ShippingPackageLabelsAddressesAddress,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Nowy adres',
            //                 requiresAuth: true,
            //                 permission: 'labels_create',
            //             },
            //         },
            //         {
            //             path: '/shipments/package-labels/addresses/edit/:id',
            //             name: 'shipmentsPackageLabelsAddressesEdit',
            //             component: ShippingPackageLabelsAddressesAddress,
            //             meta: {
            //                 title: 'Wysyłki / Zawieszki / Edycja adresu',
            //                 requiresAuth: true,
            //                 permission: 'labels_update',
            //             },
            //         },
            //     ]
            // },
            {
                path: '/shipments/package-labels-v2',
                name: 'shipmentsPackageLabels-v2',
                component: EmptyRouterView,
                meta: {
                    title: 'Wysyłki / Zawieszki',
                    menuRendered: true,
                    menuTitle: 'Zawieszki',
                    requiresAuth: true,
                    permission: 'labels',
                },
                redirect: { name: 'shipmentsPackageLabelsLabels-v2' },
                children: [
                    {
                        path: '/shipments/package-labels-v2/labels',
                        name: 'shipmentsPackageLabelsLabels-v2',
                        component: ShippingPackageLabelsLabelsV2,
                        meta: {
                            title: ' Wysyłki / Zawieszki / Etykiety',
                            requiresAuth: true,
                            permission: 'labels_read',
                        },
                    },
                    {
                        path: '/shipments/package-labels-v2/labels/create',
                        name: 'shipmentsPackageLabelsLabelsCreate-v2',
                        component: ShippingPackageLabelsLabelsLabelV2,
                        meta: {
                            title: 'Wysyłki / Zawieszki / Nowa etykieta',
                            requiresAuth: true,
                            permission: 'labels_create',
                        },
                    },
                    {
                        path: '/shipments/package-labels-v2/labels/edit/:id',
                        name: 'shipmentsPackageLabelsLabelsEdit-v2',
                        component: ShippingPackageLabelsLabelsLabelV2,
                        meta: {
                            title: 'Wysyłki / Zawieszki / Edycja etykiety',
                            requiresAuth: true,
                            permission: 'labels_update',
                        },
                    },
                    {
                        path: '/shipments/package-labels-v2/labels/edit-campaign/:id',
                        name: 'shipmentsPackageLabelsLabelsCampaignEdit',
                        component: ShippingPackageLabelsCampaignLabel,
                        meta: {
                            title: 'Wysyłki / Zawieszki / Edycja etykiety kampanii',
                            requiresAuth: true,
                            permission: 'labels_update',
                        }
                    }
                ],
            },
            {
                path: '/shipments/labels-generator',
                name: 'shipmentsLabelsGenerator',
                component: LabelsGenerator,
                meta: {
                    title: 'Wysyłki / Generator etykiet',
                    menuRendered: true,
                    menuTitle: 'Generator etykiet',
                    requiresAuth: true,
                    permission: 'sendings'
                },
                redirect: { name: 'ShippingLabelsGeneratorAll' },
                children: [
                    {
                        path: '/shipments/labels-generator',
                        name: 'ShippingLabelsGeneratorAll',
                        component: LabelsGeneratorAll,
                        meta: {
                            title: 'Wysyłki / Generator etykiet',
                            requiresAuth: true,
                            permission: 'sendings',
                        },
                    },
                    {
                        path: '/shipments/labels-generator/standard',
                        name: 'shipmentsLabelsGeneratorStandard',
                        component: StandardLabels,
                        meta: {
                            title: 'Wysyłki / Generator etykiet / Standardowe',
                            requiresAuth: true,
                            permission: 'sendings'
                        }
                    },
                    {
                        path: '/shipments/labels-generator/billboard',
                        name: 'shipmentsLabelsGeneratorBillboard',
                        component: BillboardLabels,
                        meta: {
                            title: 'Wysyłki / Generator etykiet / Billboardowe',
                            requiresAuth: true,
                            permission: 'sendings'
                        },
                    },
                    {
                        path: '/shipments/labels-generator/revision',
                        name: 'shipmentsLabelsGeneratorRevision',
                        component: RevisoryLabels,
                        meta: {
                            title: 'Wysyłki / Generator etykiet / Rewizyjne',
                            requiresAuth: true,
                            permission: 'sendings'
                        },
                    },
                    {
                        path: '/shipments/labels-generator/print-history',
                        name: 'shipmentsLabelsGeneratorPrintHistory',
                        component: LabelsPrintHistory,
                        meta: {
                            title: 'Wysyłki / Generator etykiet / Historia wydruków',
                            requiresAuth: true,
                            permission: 'sendings_admin_read'
                        },
                    }
                ],
            },
            {
                path: '/shipments/tracking',
                name: 'shipmentsTracking',
                component: ShipmentsTracking,
                meta: {
                    title: 'Wysyłki / Tracking',
                    menuRendered: true,
                    menuTitle: 'Tracking',
                    requiresAuth: true,
                    permission: 'localizations'
                },
            },
            {
                path: '/shipments/shipping-orders',
                component: EmptyRouterView,
                meta: {
                    menuRendered: true,
                    menuTitle: 'Zlecenia spedycyjne',
                    permission: 'shipping_orders',
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        name: 'shipmentsShipmentsOrders',
                        component: ShipmentsShipmentsOrders,
                        meta: {
                            title: 'Wysyłki / Zlecenia spedycyjne',
                            requiresAuth: true,
                            permission: 'shipping_orders',
                        },
                    },
                    {
                        path: '/shipments/shipping-orders/:shippingOrderId',
                        component: EmptyRouterView,
                        meta: {
                            parentName: 'shipmentsShipmentsOrders',
                            requiresAuth: true,
                            permission: 'shipping_orders'
                        },
                        children: [
                            {
                                path: '',
                                name: 'shipmentsShipmentsOrdersShipmentsOrder',
                                component: ShipmentsShipmentsOrdersShipmentsOrder,
                                meta: {
                                    title: 'Wysyłki / Zlecenia spedycyjne / Zlecenie',
                                    requiresAuth: true,
                                    permission: 'shipping_orders',
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: '/shipments/personal-pickups',
                name: 'shipmentsPersonalPickups',
                component: ShipmentsPersonalPickups,
                meta: {
                    title: 'Wysyłki / Odbiory osobiste',
                    menuRendered: true,
                    menuTitle: 'Odbiory osobiste',
                    permission: 'personal_pickups',
                    requiresAuth: true,
                },
            },
            {
                path: '/shipments/personal-pickups/create',
                name: 'shipmentsPersonalPickupsPersonalPickupCreate',
                component: ShipmentsPersonalPickupsPersonalPickup,
                meta: {
                    title: 'Wysyłki / Odbiory osobiste / Nowy odbiór osobisty',
                    requiresAuth: true,
                    permission: 'personal_pickups_create',
                },
            },
            {
                path: '/shipments/personal-packages-pickups/create',
                name: 'shipmentsPersonalPickupsPersonalPackagesPickupCreate',
                component: ShipmentsPersonalPickupsPersonalPackagesPickup,
                meta: {
                    title: 'Wysyłki / Odbiory osobiste / Nowy odbiór osobisty',
                    requiresAuth: true,
                    permission: 'personal_pickups_create',
                },
            },
            {
                path: '/shipments/personal-pickups/order/:id',
                name: 'shipmentsPersonalPickupsPersonalPickup',
                component: ShipmentsPersonalPickupsPersonalPickup,
                meta: {
                    title: 'Wysyłki / Odbiory osobiste / Odbiór osobisty',
                    requiresAuth: true,
                    permission: 'personal_pickups_read',
                },
            },
            {
                path: '/shipments/personal-pickups/package/:id',
                name: 'shipmentsPersonalPickupsPersonalPackagesPickup',
                component: ShipmentsPersonalPickupsPersonalPackagesPickup,
                meta: {
                    title: 'Wysyłki / Odbiory osobiste / Odbiór osobisty',
                    requiresAuth: true,
                    permission: 'personal_pickups_read',
                },
            },
        ]
    }
]
